// src/components/Footer.jsx
import React from "react";

const Footer = () => {
    return (
        <footer className="pc-footer">
            <div className="pc-footer-inner">
                {/* Column 1: Logo & Tagline */}
                <div className="pc-footer-logo-col">
                    <a href="https://people-click.com/" target="_blank" rel="noopener noreferrer" className="pc-footer-logo-link">
                        {/* <img src="/logo.svg" alt="Peopleclick" className="pc-logo-img" /> */}
                        <img src={`${process.env.PUBLIC_URL}/logo.svg`} alt="Peopleclick" className="pc-logo-img" />

                    </a>
                    <p className="pc-footer-desc">
                        Digital Transformation |<br />
                        Innovative Business Solutions |<br />
                        IT Services | Consulting
                    </p>
                </div>

                {/* Column 2: Address */}
                <div>
                    <div className="pc-footer-title">Peopleclick</div>
                    <address className="pc-footer-address">
                        No. 230, Level 3 ,1st Cross, 38th Main,<br />
                        BOOHBCS Layout, BTM 2nd Stage,<br />
                        Bangalore – 560 068<br />
                        Karnataka, India
                    </address>
                </div>

                {/* Column 3: Contact Email */}
                <div>
                    <div className="pc-footer-title font-semibold">Email</div>
                    <div className="pc-footer-contact-row">
                        <div className="pc-footer-email-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                <polyline points="22,6 12,13 2,6" />
                            </svg>
                        </div>
                        <div className="pc-footer-email-text">
                            <span className="pc-footer-email-label">Get in Touch</span>
                            <a href="mailto:info@people-click.com" className="pc-footer-email-link">
                                info@people-click.com
                            </a>
                        </div>
                    </div>
                </div>

                {/* Column 4: Social Icons */}
                <div>
                    <div className="pc-footer-title">Follow Us</div>
                    <div className="pc-footer-socials">
                        {/* Facebook */}
                        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="pc-footer-social-btn" aria-label="Facebook">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                            </svg>
                        </a>
                        {/* X (Twitter) */}
                        <a href="https://x.com" target="_blank" rel="noopener noreferrer" className="pc-footer-social-btn" aria-label="X (formerly Twitter)">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M4 4l11.733 16h4.267l-11.733 -16z" />
                                <path d="M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772" />
                            </svg>
                        </a>
                        {/* Instagram */}
                        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="pc-footer-social-btn" aria-label="Instagram">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                            </svg>
                        </a>
                        {/* LinkedIn */}
                        <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="pc-footer-social-btn" aria-label="LinkedIn">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                                <rect x="2" y="9" width="4" height="12" />
                                <circle cx="4" cy="4" r="2" />
                            </svg>
                        </a>
                    </div>
                </div>
            </div>

            {/* Bottom Row */}
            <div className="pc-footer-bottom">
                <div className="pc-footer-bottom-inner">
                    <div className="pc-footer-copy">
                        © 2025 all rights reserved Peopleclick
                    </div>
                    <a href="https://people-click.com/" target="_blank" rel="noopener noreferrer" className="pc-footer-credits">
                        Credits
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
